import { Router, } from "@angular/router";
import { AccountService } from "./account.service";
import { Observable } from "rxjs";
import { finalize } from "rxjs/operators";
import * as i0 from "@angular/core";
import * as i1 from "./account.service";
import * as i2 from "@angular/router";
var AccountGuard = /** @class */ (function () {
    function AccountGuard(accountService, router) {
        this.accountService = accountService;
        this.router = router;
    }
    AccountGuard.prototype.canActivate = function (route, state) {
        return this.comprobarSiLaSesionNoEsAnonima();
    };
    AccountGuard.prototype.canLoad = function (route, segments) {
        return this.comprobarSiLaSesionNoEsAnonima();
    };
    AccountGuard.prototype.comprobarSiLaSesionNoEsAnonima = function () {
        var _this = this;
        var result = false;
        if (!!this.accountService.getToken() &&
            this.accountService.getToken() !== "" &&
            !this.accountService.isAuthenticated()) {
            return new Observable(function (subscriber) {
                _this.accountService
                    .identity(true)
                    .pipe(finalize(function () {
                    subscriber.complete();
                }))
                    .subscribe(function (account) {
                    result = !_this.isAnonymous(account);
                    subscriber.next(result);
                });
            });
        }
        else {
            result = !this.accountService.isAnonymous();
        }
        if (!result) {
            this.router.navigate([""]);
        }
        return result;
    };
    AccountGuard.prototype.isAuthenticated = function (account) {
        return !!account && account !== null;
    };
    AccountGuard.prototype.isAnonymous = function (account) {
        if (this.isAuthenticated(account)) {
            if (!!account.authType) {
                return account.authType === null || account.authType === "ANONIMO";
            }
        }
        return true;
    };
    AccountGuard.ngInjectableDef = i0.defineInjectable({ factory: function AccountGuard_Factory() { return new AccountGuard(i0.inject(i1.AccountService), i0.inject(i2.Router)); }, token: AccountGuard, providedIn: "root" });
    return AccountGuard;
}());
export { AccountGuard };
